const PALETTE = [
    'text-blue-700',
    'text-emerald-700',
    'text-violet-700',
    'text-amber-700',
    'text-teal-700',
    'text-rose-700',
    'text-indigo-700',
    'text-orange-700',
    'text-cyan-700',
    'text-pink-700'
];

const BG_PALETTE = [
    'bg-blue-50',
    'bg-emerald-50',
    'bg-violet-50',
    'bg-amber-50',
    'bg-teal-50',
    'bg-rose-50',
    'bg-indigo-50',
    'bg-orange-50',
    'bg-cyan-50',
    'bg-pink-50'
];

function hash(str: string): number {
    let h = 0;
    for (let i = 0; i < str.length; i++) {
        h = ((h << 5) - h + str.charCodeAt(i)) | 0;
    }
    return Math.abs(h);
}

export function getStatusColor(value: string): string {
    return PALETTE[hash(value) % PALETTE.length];
}

export function getStatusBgColor(value: string): string {
    return BG_PALETTE[hash(value) % BG_PALETTE.length];
}

export function getStatusColors(value: string): { text: string; bg: string } {
    const idx = hash(value) % PALETTE.length;
    return { text: PALETTE[idx], bg: BG_PALETTE[idx] };
}

// Hex twins of the solid pill palette (Tailwind 600 shades), for chart fills where
// class names cannot be used. Index-aligned so a category keeps the same hue
// in pills and charts.
const HEX_PALETTE = [
    '#2563eb', // blue-600
    '#059669', // emerald-600
    '#7c3aed', // violet-600
    '#d97706', // amber-600
    '#0d9488', // teal-600
    '#e11d48', // rose-600
    '#4f46e5', // indigo-600
    '#ea580c', // orange-600
    '#0891b2', // cyan-600
    '#db2777' // pink-600
];

export function getStatusChartHex(value: string): string {
    return HEX_PALETTE[hash(value) % HEX_PALETTE.length];
}
